import css from './NewHeroSection.module.css';
import heroBg from '../../../../assets/Hero-Section-Banner.png';
import planningPortalIcon from '../../../../assets/PlanningPortalSVG.svg';

const STATS = [
  { value: '£200B+', label: 'Commercial demand unlocked' },
  { value: '4000+', label: 'New projects added weekly' },
  { value: '700k+', label: 'Live projects tracked' },
];

const NewHeroSection = () => {
  return (
    <div className={css.wrapper}>
      <img src={heroBg} alt="" className={css.bgImage} aria-hidden="true" />
      <div className={css.overlay} />

      <div className={css.content}>
        {/* Planning Portal */}
        <div className={css.collaborationBadge}>
          <span className={css.collaborationText}>In collaboration with</span>
          <img src={planningPortalIcon} alt="Planning Portal icon" className={css.planningIcon} />
          <span className={css.planningLogoText}>
            <span className={css.planningBold}>Planning</span>Portal
          </span>
        </div>

        {/* Main Heading */}
        <h1 className={css.heading}>
          The easiest way to<br />
          <span className={css.highlight}>connect</span>{' '}construction<br />
          <span className={css.noWrap}>supply with <span className={css.highlight}>real demand</span></span>
        </h1>

        {/* Subtext */}
        <p className={css.subtext}>
          See live projects. Connect with the right people. Build with confidence.
        </p>

        {/* Stats */}
        <div className={css.statsRow}>
          {STATS.map((stat) => (
            <div key={stat.value} className={css.statItem}>
              <span className={css.statValue}>{stat.value}</span>
              <span className={css.statLabel}>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewHeroSection;
